import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import IconButton from 'modules/custom_resources/components/CustomFields/FieldModal/Choices/IconButton'
import Input from 'modules/custom_resources/components/CustomFields/FieldModal/Choices/Input'
import { Option } from 'modules/legal_entities/pages/settings/ContractsLegalEntityPage/ContractFields/types'

type Props = {
  options: Option[]
  onAddOption: () => void
  onOptionAction: (action: 'delete' | 'edit' | 'archive', index: number, value?: string) => void
}

const SingleChoice = ({ options, onAddOption, onOptionAction }: Props) => {
  const draftOptions = options.filter((option) => option.draft)
  const createdOptions = options.filter((option) => !option.draft)
  const archivedOptions = createdOptions.filter((option) => !option.isActive)
  const activatedOptions = createdOptions.filter((option) => option.isActive)
  const createdOptionsOrdered = [...activatedOptions, ...archivedOptions, ...draftOptions]

  const handleDelete = (index: number) => {
    onOptionAction('delete', index)
  }

  const handleEdit = (index: number, newValue: string) => {
    onOptionAction('edit', index, newValue)
  }

  const handleArchive = (index: number) => {
    onOptionAction('archive', createdOptionsOrdered[index]?.id || index)
  }

  return (
    <Box gap="s16">
      <Text.Normal size="200" color="grey800">
        {i18n.t('settings.custom_fields.new.labels.single_choice_options.description')}
      </Text.Normal>
      <Box gap="s8">
        {createdOptionsOrdered.map((option, index) => (
          <Box key={index} flexDirection="row" justifyContent="spaceBetween" alignItems="center">
            <Input
              label={option.label || ''}
              disabled={false}
              onChange={(value) => handleEdit(index, value)}
              archived={!option.isActive}
              draft={option.draft ?? false}
            />
            <Box paddingLeft="s8" paddingTop="s8">
              <IconButton
                disabled={false}
                archived={!option.isActive}
                draft={option.draft ?? false}
                archiveHandler={() => handleArchive(index)}
                deleteHandler={() => handleDelete(index)}
              />
            </Box>
          </Box>
        ))}
      </Box>
      <Button type="secondary" onClick={onAddOption} disabled={false} iconName="add">
        {i18n.t('settings.custom_fields.new.labels.single_choice_options.add')}
      </Button>
    </Box>
  )
}

export default SingleChoice
